var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0E4EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4984 18.3984L12.9489 20.0448C12.2892 20.2835 12.2892 21.2165 12.9489 21.4552L17.4984 23.1016C17.9171 23.2531 18.2469 23.5829 18.3984 24.0016L20.0448 28.5511C20.2835 29.2108 21.2165 29.2108 21.4552 28.5511L23.1016 24.0016C23.2531 23.5829 23.5829 23.2531 24.0016 23.1016L28.5511 21.4552C29.2108 21.2165 29.2108 20.2835 28.5511 20.0448L24.0016 18.3984C23.5829 18.2469 23.2531 17.9171 23.1016 17.4984L21.4552 12.9489C21.2165 12.2892 20.2835 12.2892 20.0448 12.9489L18.3984 17.4984C18.2469 17.9171 17.9171 18.2469 17.4984 18.3984Z",
    stroke: "#BF50B2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6581 31.477L28.8905 32.5122C28.9545 32.7974 29.2077 33 29.5 33C29.7923 33 30.0455 32.7974 30.1095 32.5122L30.3419 31.4769C30.469 30.911 30.911 30.469 31.4769 30.3419L32.5121 30.1095C32.7973 30.0455 33 29.7923 33 29.5C33 29.2077 32.7973 28.9545 32.5121 28.8905L31.4769 28.6581C30.911 28.5311 30.469 28.0891 30.3419 27.5231L30.1095 26.4879C30.0455 26.2027 29.7923 26 29.5 26C29.2077 26 28.9545 26.2027 28.8905 26.4879L28.6581 27.5231C28.531 28.0891 28.089 28.5311 27.5231 28.6581L26.4879 28.8905C26.2027 28.9545 26 29.2077 26 29.5C26 29.7923 26.2027 30.0455 26.4879 30.1095L27.5231 30.3419C28.089 30.469 28.531 30.911 28.6581 31.477Z",
    fill: "#BF50B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/Spark.d09f0a334bbca4f55b5498e4656c4ee1.svg";
export { ForwardRef as ReactComponent };